import { TemplateConfig } from '../../template-config.interface';

export const disneyGrid: TemplateConfig = {
  id: 'grid',
  clientId: 'DISNEY',
  title: 'Grilla',
  description: 'Template tipo grilla',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/grilla.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/grilla.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/grilla.mp4',
  formFields: [],
  promptTemplate: ''
};
